import { flexRender, Header } from "@tanstack/react-table";

import { ArrowIcon } from "~/common/components/icons";
import { TableHeader } from "~/common/components/table/TableHeader";
import { DIRECTIONS } from "~/common/constants";

interface SortableTableHeaderProps<T> {
  header: Header<T, unknown>;
  className?: string;
}

export const SortableTableHeader = <T,>({
  header,
  className,
}: SortableTableHeaderProps<T>) => {
  const sorted = header.column.getIsSorted();
  const direction =
    sorted === "desc"
      ? DIRECTIONS.down
      : sorted === "asc"
        ? DIRECTIONS.top
        : DIRECTIONS.top;

  return (
    <TableHeader className={className} scope="col">
      <button
        type="button"
        className="flex w-full items-center gap-2"
        onClick={header.column.getToggleSortingHandler()}
      >
        {flexRender(header.column.columnDef.header, header.getContext())}
        <ArrowIcon
          className={sorted ? "size-2.5" : "size-2.5 opacity-0"}
          direction={direction}
        />
      </button>
    </TableHeader>
  );
};
